/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Calc_Seats_LabelInputs */

const en_mk_calc_seats_label = /** @type {(inputs: Mk_Calc_Seats_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`People on the team`)
};

const id_mk_calc_seats_label = /** @type {(inputs: Mk_Calc_Seats_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jumlah anggota tim`)
};

/**
* | output |
* | --- |
* | "People on the team" |
*
* @param {Mk_Calc_Seats_LabelInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_calc_seats_label = /** @type {((inputs?: Mk_Calc_Seats_LabelInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Calc_Seats_LabelInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_calc_seats_label(inputs)
	return en_mk_calc_seats_label(inputs)
});